interface ChipProps {
  children: React.ReactNode;
  variant?: 'default' | 'success' | 'primary';
}

/**
 * Chip component for tags and badges
 * Used to highlight features, availability, or status
 *
 * @example
 * <Chip variant="primary">Batch & Web</Chip>
 * <Chip variant="success">AI</Chip>
 */
export function Chip({
  children,
  variant = 'default'
}: ChipProps) {
  const variants = {
    default: "bg-[#F7F9FC] text-[#5F6B7A] border-[#E6ECF2]",
    success: "bg-[#25C281]/10 text-[#25C281] border-[#25C281]/20",
    primary: "bg-[#2F7BFF]/10 text-[#2F7BFF] border-[#2F7BFF]/20"
  };

  return (
    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border ${variants[variant]}`}>
      {children}
    </span>
  );
}
